import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children, color = "bg-staxyellow text-ink" }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono2 text-xs font-bold tracking-[0.25em] uppercase px-3 py-1.5 border-2 border-ink ${color}`}
  >
    {children}
  </span>
);

export const BigHead = ({ children, className = "" }) => (
  <h2
    className={`font-display uppercase leading-[0.92] text-4xl sm:text-5xl lg:text-6xl ${className}`}
  >
    {children}
  </h2>
);
